<div
  (click)="handleClick($event)"
  (mousedown)="handleMouseDown()"
  (mouseup)="handleMouseUp()"
  (touchstart)="handleMouseDown()"
  (touchend)="handleMouseUp()"
  class="flow-button">
  <button [class.active]="isActive" [tabIndex]="tabindex" [disabled]="disabled" [type]="type" (click)="handleClick($event)">
    @if (icon !== '') {
      <ion-icon [name]="icon"></ion-icon>
    }
    <ng-content></ng-content>
  </button>
</div>
